import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PathwayRouter from "@/pages/PathwayRouter";
import Checkup from "@/pages/Checkup";
import BookingPage from "@/pages/BookingPage";
import Tools from "@/pages/Tools";
import Learn from "@/pages/Learn";
import ArticlePage from "@/pages/ArticlePage";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import AdminLogin from "@/pages/admin/Login";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import VerifyEmail from "@/pages/admin/VerifyEmail";
import AdminDashboard from "@/pages/admin/Dashboard";
import NotFound from "@/pages/NotFound";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App">
      {!isAdmin && <Navbar />}
      <main className={isAdmin ? "" : "pb-20 md:pb-0"}>
        <Routes>
          <Route path="/" element={<PathwayRouter />} />
          <Route path="/checkup" element={<Checkup key="complete" pathwayKey="complete" />} />
          <Route path="/checkup/legacy" element={<Checkup key="legacy" pathwayKey="legacy" />} />
          <Route path="/checkup/family" element={<Checkup key="family" pathwayKey="family" />} />
          <Route path="/checkup/medicare" element={<Checkup key="medicare" pathwayKey="medicare" />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/learn" element={<Learn />} />
          <Route path="/learn/:slug" element={<ArticlePage />} />
          <Route path="/book" element={<BookingPage pathwayKey="legacy" />} />
          <Route path="/book/:pathway" element={<BookingPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<LegalPage page="privacy" />} />
          <Route path="/terms" element={<LegalPage page="terms" />} />
          <Route path="/accessibility" element={<LegalPage page="accessibility" />} />
          <Route path="/disclosures" element={<LegalPage page="disclosures" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/admin/verify-email" element={<VerifyEmail />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </HelmetProvider>
  );
}
